import {FinPayRiskClass} from "../../admin-configuration/models/risk-class-setting";
import {
    RiskStatus, AdmitStatus, Estimate
} from "@finpay/estimation-types";

export { RiskStatus, AdmitStatus };

export const ThresholdEnum = {
    PFRCONCRISK: "PFRCONCRISK",
    PROFITABILITYRISK: "PROFITABILITYRISK",
    INPATREFSRCPROFITRISK: "INPATREFSRCPROFITRISK",
    OUTPATREFSRCPROFITRISK: "OUTPATREFSRCPROFITRISK",
    AMARISK: "AMARISK"
};

export interface RiskAssessmentForm {
    isValid: boolean;
    facility: {
        facilityId?: number; facilityName?: string;
    };
    facilityIds: number[];
    facilityCensus?: number;
    payorRisk: {
        payorRiskId?: number;
        payorRiskName?: string;
    };
    timingRisk: {
        timingRiskId?: number;
        timingRiskName?: string;
    };
    riskClass: {
        riskClassId?: number;
        riskClassName?: string;
    };
    referralSource: {
        facilityReferralSourceId?: number;
        facilityReferralSourceName?: string;
    };
    compareBest: boolean;
    showCleared: boolean;
}

export interface FacilityRiskThreshold {
    paramId?: number | undefined;
    facilityRiskThresholdId?: number | null;
    clientFacilityId?: number | null;
    cfgRiskThresholdId?: number | null;
    cfgRiskThresholdCode?: string | null | undefined;
    lowRisk?: number | null;
    mediumRisk?: number | null;
    highRisk?: number | null;
}

export interface MultiFacilityRiskThreshold {
    clientFacilityId: number;
    facilityRiskThresholds: FacilityRiskThreshold[];
}

export interface ClientRiskClassSettings {
    clientRiskClassSettingId?: number;
    clientId: number;
    riskClassId: number;
    riskClassCleared: number;
    riskClassHre: number;
}

export interface FacilityRiskClassSettings {
    facilityRiskClassSettingId?: number;
    clientFacilityId: number;
    riskClassId: number;
    riskClassCleared: number;
    riskClassHre: number;
}

export interface ClientDeficiencySettings {
    isEiv: boolean;
    addedToDownpayment: boolean;
    downpaymentPct: number;
}

export interface MultiFacilityRiskClassSetting {
    clientFacilityId: number;
    facilityRiskClassSettings: FacilityRiskClassSettings[];
}

export interface MultiFacilityRiskClass {
    clientFacilityId: number;
    facilityRiskClass: FinPayRiskClass[];
}

export interface PayerClaimRate {
    paramId?: number | undefined;
    clientPayorClaimrateId?: number | undefined | null,
    clientId: number,
    cfgPayorId?: number | undefined | null,
    cfgPayorPlanId?: number | undefined | null,
    claimRatePct?: number,
}

export interface RiskAssessmentEstimate {
    isValid: boolean;
    estimateBody: Estimate;
}

export interface ValueRisk {
    value: number;
    risk: RiskStatus;
}

export interface PfrEiv {
    pfr: number;
    eiv: number;
    estimate?: Estimate | null | undefined;
}

export interface EditedFacilityCensus {
    facilityId: number;
    census: number;
}

export interface ReferralSourceRevenue {
    facilityLocReferralSourceId: number;
    clientFacilityId: number;
    facilityLevelOfCareId: number,
    clientReferralSourceId?: number | null | undefined;
    facilityReferralSourceId: number,
    locReferralRevenue?: number
}

export interface PatientEpisodeMarginSettings {
    clientPatientEpisodeMarginId?: number | null | undefined;
    clientId?: number | null | undefined;
    isEiv?: boolean | null | undefined,
    isFacilityCost?: boolean | null | undefined,
    variableCostPct?: number | null | undefined;
}

export const emptyPatientEpisodeMarginSettings: PatientEpisodeMarginSettings = {
    clientPatientEpisodeMarginId: null, clientId: null, isEiv: false, isFacilityCost: false, variableCostPct: null
} 